import { render } from "./AppGeneralTaxesBlock.vue?vue&type=template&id=3313f356&scoped=true"
import script from "./AppGeneralTaxesBlock.vue?vue&type=script&lang=js"
export * from "./AppGeneralTaxesBlock.vue?vue&type=script&lang=js"

import "./AppGeneralTaxesBlock.vue?vue&type=style&index=0&id=3313f356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3313f356"]])

export default __exports__